import { MEETING_LINK_CONSULTING_QC_EN, MEETING_LINK_CONSULTING_QC_FR, MEETING_LINK_ROADMAP_FR, MEETING_LINK_ROADMAP_QC_EN, MEETING_LINK_ROADMAP_ROC_EN, MEETING_LINK_SDR_ROC_EN, MEETING_LINK_SDR_ROC_FR, MEETING_LINK_ZOOM_PLATFORM, } from '../links';
import { isNonProfitOrganization } from './check-company-icp';
export function resolveAppHeader(selectedLocale, accessLevel, company, admin, handleCheckout) {
    const isEnglish = selectedLocale === 'en';
    const isFromQuebec = company.province === 'QC';
    const revenue = company.annual_revenue;
    const isCompanyNPO = isNonProfitOrganization(company.legal_structure || '');
    if (accessLevel === 'custom') {
        if (isEnglish) {
            return {
                title: 'Talk to my account manager',
                link: (admin === null || admin === void 0 ? void 0 : admin.meeting_link_en) || 'app.hellodarwin.com/contact-us',
                variant: 'main-action',
            };
        }
        else {
            return {
                title: 'Parler à mon gestionnaire de compte',
                link: (admin === null || admin === void 0 ? void 0 : admin.meeting_link_fr) || 'app.hellodarwin.com/contact-us',
                variant: 'main-action',
            };
        }
    }
    if (accessLevel === 'premium' || accessLevel === 'expert') {
        if (isEnglish) {
            return {
                title: 'Register for an information session',
                link: MEETING_LINK_ZOOM_PLATFORM,
                variant: 'main-action',
            };
        }
        else {
            return {
                title: "M'inscrire à une session d'information",
                link: MEETING_LINK_ZOOM_PLATFORM,
                variant: 'main-action',
            };
        }
    }
    if (isEnglish) {
        if (isFromQuebec) {
            if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
                return {
                    title: 'Talk to an expert',
                    link: MEETING_LINK_ROADMAP_QC_EN,
                    variant: 'main-action',
                };
            }
            if (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Talk to an expert',
                    link: MEETING_LINK_CONSULTING_QC_EN,
                    variant: 'main-action',
                };
            }
            else {
                return {
                    title: 'See our plans',
                    action: handleCheckout,
                };
            }
        }
        if (!isFromQuebec) {
            if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
                return {
                    title: 'Talk to an expert',
                    link: MEETING_LINK_ROADMAP_ROC_EN,
                    variant: 'main-action',
                };
            }
            if (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Talk to an expert',
                    link: MEETING_LINK_SDR_ROC_EN,
                    variant: 'main-action',
                };
            }
            else {
                return {
                    title: 'See our plans',
                    action: handleCheckout,
                };
            }
        }
    }
    if (!isEnglish) {
        if (isFromQuebec) {
            if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
                return {
                    title: 'Parler à un expert',
                    link: MEETING_LINK_ROADMAP_FR,
                    variant: 'main-action',
                };
            }
            if (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Parler à un expert',
                    link: MEETING_LINK_CONSULTING_QC_FR,
                    variant: 'main-action',
                };
            }
            else {
                return {
                    title: 'Voir nos plans',
                    action: handleCheckout,
                };
            }
        }
        if (!isFromQuebec) {
            if (!isCompanyNPO && (revenue === '100m' || revenue === '100m+')) {
                return {
                    title: 'Parler à un expert',
                    link: MEETING_LINK_ROADMAP_FR,
                    variant: 'main-action',
                };
            }
            if (revenue === '10m' ||
                revenue === '20m' ||
                revenue === '25m' ||
                revenue === '50m' ||
                revenue === '100m' ||
                revenue === '100m+') {
                return {
                    title: 'Parler à un expert',
                    link: MEETING_LINK_SDR_ROC_FR,
                    variant: 'main-action',
                };
            }
            else {
                return {
                    title: 'Voir nos plans',
                    action: handleCheckout,
                };
            }
        }
    }
    return {
        title: 'Voir nos plans',
        action: handleCheckout,
    };
}
